import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTechPredAuth } from './Auth/TechPredAuthProvider';

export function TechPredheader() {
  const navigate = useNavigate();
  const location = useLocation();
  const { techpredlogout } = useTechPredAuth();

  const handleLogout = () => {
    localStorage.removeItem("techpredtoken");
    techpredlogout();
    navigate('techpred/login');
  };

  const showHome = ['/techpred/login', '/techpred/home'].includes(location.pathname);
  const showLogout = location.pathname === '/techpred/chat';

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 4,
        py: 2,
        zIndex: 1100,
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        background: 'linear-gradient(90deg, #6366f1, #4f46e5)', // gradient for modern feel
        color: 'white',
        borderBottom: '1px solid #e5e7eb',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          fontSize: { xs: '1.5rem', sm: '1.75rem', md: '1.7rem' },
          letterSpacing: '0.5px',
          fontFamily: 'Roboto, sans-serif',
          color: '#ffffff'
        }}
      >
        PickMyStack
      </Typography>

      <Box>
        {showHome && (
          <Button
            variant="outlined"
            sx={{
              color: 'white',
              borderColor: 'white',
              mr: 2,
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.1)',
                borderColor: '#c7d2fe'
              }
            }}
            onClick={() => navigate('/')}
          >
            Home
          </Button>
        )}
        {showLogout && (
          <Button
            variant="outlined"
            sx={{
              color: 'white',
              borderColor: 'white',
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.1)',
                borderColor: '#fca5a5'
              }
            }}
            onClick={handleLogout}
          >
            Logout
          </Button>
        )}
      </Box>
    </Box>
  );
}
